var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleDiscount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#F7ECEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5899 9.41005C23.1367 9.95678 23.1367 10.8432 22.5899 11.39L11.39 22.5899C10.8432 23.1367 9.95678 23.1367 9.41005 22.5899C8.86332 22.0432 8.86332 21.1568 9.41005 20.6101L20.6101 9.41005C21.1568 8.86332 22.0432 8.86332 22.5899 9.41005Z",
    fill: "#B91618"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5333 20.6667C22.5333 21.6976 21.6976 22.5333 20.6667 22.5333C19.6357 22.5333 18.8 21.6976 18.8 20.6667C18.8 19.6357 19.6357 18.8 20.6667 18.8C21.6976 18.8 22.5333 19.6357 22.5333 20.6667Z",
    fill: "#B91618"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 11.3333C13.2 12.3643 12.3643 13.2 11.3333 13.2C10.3024 13.2 9.46667 12.3643 9.46667 11.3333C9.46667 10.3024 10.3024 9.46667 11.3333 9.46667C12.3643 9.46667 13.2 10.3024 13.2 11.3333Z",
    fill: "#B91618"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDiscount);
export default __webpack_public_path__ + "static/media/circleDiscount.333875edd889497816d9fad9c66ae2d6.svg";
export { ForwardRef as ReactComponent };